import { IState } from 'models';
import { useEffect, useState } from 'react';
import { Api } from 'services/api';
import { BaseGetAllParams } from 'services/defaults';
import { GetAll } from 'services/state.service';

interface FetchStatesProps extends BaseGetAllParams {
  idCountry?: string;
}

function mapState(item: IState) {
  return {
    ...item,
  };
}

export function useStates(props: FetchStatesProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const [data, setData] = useState<IState[]>();
  const [total, setTotal] = useState<number>();
  const [pagination, setPagination] = useState({ pageSize: 100, pageNumber: 1 });

  const load = async () => {
    if (!props.idCountry) {
      return;
    }

    const filters = {
      pageNumber: props.pageNumber ?? pagination.pageNumber,
      pageSize: props.pageSize ?? pagination.pageSize,
      idCountry: props.idCountry,
    };

    setLoading(true);
    await Api.tryCatch(
      GetAll(filters, { cancelToken: cancelToken.token }),
      (rs) => {
        setLoading(false);
        setData(rs.data.map(mapState));
        setTotal(rs.meta.total);
      },
      (err) => {
        setLoading(false);
        setError(err.message);
      },
    );
  };

  let cancelToken = Api.getCancelTokenSource();
  useEffect(() => {
    cancelToken = Api.getCancelTokenSource();
    return () => {
      cancelToken.cancel();
    };
  }, []);

  useEffect(() => {
    load();
  }, [props.idCountry, props.pageNumber, props.pageSize, pagination]);

  return { loading, error, data, total, pagination, setPagination, reloadList: load };
}
